// extracted by css-extract-rspack-plugin
export default {"root":"root-M9o8NC","section":"section-zW_44I"};